import { useContext } from 'react';
import { FolderActionsContext } from '../Context';

export const useFolderActions = () => {
  const actions = useContext(FolderActionsContext);

  return actions;
};

export default useFolderActions;